// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nmain[data-v-5031b956] {\n  position: absolute;\n  left: 0;\n  right: 0;\n  min-height: 90vh;\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n}\n.summary[data-v-5031b956] {\n  margin: 0 1em;\n}\n", ""]);
// Exports
module.exports = exports;
